import { ErrorBoundaryFallbackProps } from "@suspensive/react";
import React, { useContext } from "react";
import { ErrorPageProps } from "shared/components/empty/ErrorPageProps";
import { GenericErrorPageView } from "shared/components/empty/GenericErrorPageView";
import PageBody from "shared/components/layout/PageBody";
import PageContainer, {
  PageContainerContext,
  PageContainerContextValue,
} from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";

export const GenericErrorPage: React.FC<ErrorPageProps> = (props) => {
  const existingContext = useContext(PageContainerContext) as
    | PageContainerContextValue
    | undefined;
  const content = (
    <PageContent isFullHeight={true}>
      <PageBody data-ls-enabled={true} data-public={true}>
        <GenericErrorPageView {...props} />
      </PageBody>
    </PageContent>
  );
  return existingContext ? content : <PageContainer>{content}</PageContainer>;
};

export const GenericErrorPageFallback: React.FC<ErrorBoundaryFallbackProps> = (
  props,
) => <GenericErrorPage {...props} />;
